module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/3.f1d09d59.png";